import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

interface GuideConversionInfo {
    guideId: string;
    conversionItemId: string;
    conversionItemType: string;
}

export default {
    name: 'TotalVisitorsAndAccountsInfluencedAggregation',
    productArea: PRODUCT_AREAS.IMPACT_BRIEF,
    subProductArea: SUB_PRODUCT_AREAS.ONBOARDING,
    responseFormat: 'row',
    build: ({ firstComparisonRange, guides }: { firstComparisonRange: string; guides: GuideConversionInfo[] }) => {
        if (!guides.length) {
            throw new Error('guides is requied for TotalVisitorsAndAccountsInfluencedAggregation');
        }

        if (!firstComparisonRange) {
            throw new Error('comparisonRange is required for TotalVisitorsAndAccountsInfluencedAggregation');
        }

        return o.pipeline(
            o.spawn(
                ...guides.map((guide) => {
                    const itemSeenFieldName = `${guide.conversionItemType}_itemSeen`;

                    return o.pipeline(
                        o.sources.guideEvents({
                            guideId: guide.guideId,
                            timeSeries: {
                                first: firstComparisonRange,
                                last: 'dateAdd(startOfPeriod("daily", now()), -1, "days")',
                                period: 'dayRange',
                            },
                        }),
                        o.filter('type == "guideSeen" && guideSeenReason != "continue"'),
                        o.itemSeen(guide.conversionItemType, guide.conversionItemId, itemSeenFieldName),
                        o.filter(`${itemSeenFieldName}.lastUsed >= browserTime`),
                        o.reduce({
                            converted: o.count('visitorId'),
                            accountCount: o.count('accountId'),
                        }),
                    );
                }),
            ),
            o.reduce({
                totalVisitorsInfluenced: o.sum('converted'),
                totalAccountsInfluenced: o.sum('accountCount'),
            }),
            o.evalExpression({
                id: '"totalVisitorsAndAccountsInfluencedAggregation"',
            }),
        );
    },
};
